import { __BetCardDTO } from "../types/dynamic.type";
import { getUniqueID } from "./validation.helper";

export const getBetId = (pool: string, betCards: __BetCardDTO) => {
  let key = getUniqueID(pool);
  if (betCards && betCards[key]) getBetId(pool, betCards);
  return key;
};
